module.exports = __webpack_public_path__ + "img/BastelnImZoo.3eb16e1e.svg";